
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Die Sterblichkeitsrate in China bei Männern betrug 2,8% und bei Frauen 1,7%.
  Und Patienten in der Provinz Hubei hatten mit 2,9% eine siebenfach höhere
  Sterblichkeitsrate im Vergleich zu Patienten in anderen chinesischen Provinzen (0,4%).
    </p>
    <p>
  In Italien waren neun Verstorbene unter 40 Jahre, alle waren krank, ehe sie sich
  mit dem Virus infizierten. Über 70 Prozent der Opfer sind Männer. Frauen seien
  besser darin, Viren zu bekämpfen, vermuten die Ärzte. Auch die Immunantwort nach
  Impfungen ist im Vergleich zu Männern erhöht. Gleiches gilt für das sogenannte
  Immungedächtnis, das den Körper nach einer überstandenen Infektion vor einer
  erneuten Ansteckung schützt. Neben dem Immunsystem könnte aber auch der
  unterschiedliche Lebensstil eine Rolle im Verlauf der Lungenkrankheit
  spielen, vermuten Experten.
    </p>
    <p>
  Nur wenige Personen in Italien starben offenbar ausschliesslich «am»
  Coronavirus – «ohne Wenn und Aber», wie die Italiener sagen. Alle anderen
  litten an mindestens einer schweren Vorerkrankung. Die Hälfte hatte drei
  oder mehr Krankheiten, die häufigsten waren: Bluthochdruck, Diabetes,
  Krebs, Herz- und Atembeschwerden.
    </p>
    <p>
  Italiens Gesundheitsinstitut führt auch auf, mit welchen Leiden die
  Menschen eingeliefert wurden. 77 Prozent hatten hohes Fieber, 74 Prozent
  litten an Dyspnoe, also Atemnot, und 42 Prozent klagten vor allem über Husten.
    </p>
    <p>
  Insgesamt infizierten sich in China auch 1716 Ärzte und Spitalangestellte
  mit dem Virus. Fünf starben, was einer Todesrate von 0,3% entspricht.
    </p>
    <p>
  Während Patienten ohne Vorerkrankungen eine Sterblichkeitsrate von 0,9% aufweisen,
  steigt die Rate bei Patienten mit Herz-Kreislauf-Erkrankungen, Diabetes,
  chronischen Atemwegserkrankungen, Bluthochdruck und Krebs drastisch an.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;